import React, { useContext, useEffect ,useState} from 'react'

//Components
import Header from "../Components/ProfileRegisterationOtp/Header"
import OtpSection from '../Components/ProfileRegisterationOtp/OtpSection'
import Bannersection from '../Components/ProfileRegisterationOtp/Bannersection'
import MobileviewOptSection from '../Components/ProfileRegisterationOtp/MobileviewOptSection'
import Footer from '../Components/Footer/Footer'
import MobileFooter from './Footer/MobileFooter'
import Loader from "../Components/Loader";
import $ from "jquery"

//context
import { LoginContext } from '../Contexts/LoginContext'
import Constants from '../Constants/constants'

const ProfileRegisterationOtp = (props) => {

  const [isLoadingProfile, setisLoadingProfile] = useState(true); 
  //console.log(props.isLoading,"props.isLoading");
  const {logout} = useContext(LoginContext)
  const isCommunitySite = localStorage.getItem(Constants.loginLocalStorageKeys.isCommunitySite);
  useEffect(() => {
    setisLoadingProfile(false)
    // alert(window.location.href)
    window.onpopstate = ()=> {
        if(window.location.href.indexOf('dashboard')>-1 || window.location.href.indexOf('mobileVerification')>-1){
          logout();
        }
      }
  },[])

  const scriptToInject = `
  <div class="pixelScript">
  <!-- Google tag (gtag.js) -->
  <script async src="https://www.googletagmanager.com/gtag/js?id=AW-875555676"></script>
  <script>
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
  
    gtag('config', 'AW-875555676');
  </script>
<!-- Taboola Pixel Code -->
<script type='text/javascript'>
  window._tfa = window._tfa || [];
  window._tfa.push({notify: 'event', name: 'page_view', id: 1728611});
  !function (t, f, a, x) {
         if (!document.getElementById(x)) {
            t.async = 1;t.src = a;t.id=x;f.parentNode.insertBefore(t, f);
         }
  }(document.createElement('script'),
  document.getElementsByTagName('script')[0],
  '//cdn.taboola.com/libtrc/unip/1728611/tfa.js',
  'tb_tfa_script');
</script>
<!-- End of Taboola Pixel Code -->
  </div>

  `;

  const gtmscript = `<!-- Google Tag Manager -->
<script class="gtmscript">(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-PJ95CPWZ');</script>
<!-- End Google Tag Manager -->`;

  const noScript = `<!-- Google Tag Manager (noscript) -->
      <noscript class="gtmnoscript"><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-PJ95CPWZ"
      height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
      <!-- End Google Tag Manager (noscript) -->`;


  useEffect(() => {
    if(isCommunitySite){
      //no script for this community site
    }else{
      if ($('.pixelScript').length > 0) {
        $('.pixelScript').remove()
        $('head').append(scriptToInject)
      } else {
        document.head.insertAdjacentHTML("beforeend", scriptToInject);
      }

      if(document.getElementsByClassName("gtmscript").length > 0){
          //no script for this
      }else{
        document.head.insertAdjacentHTML("beforeend", gtmscript);
      }

      if(document.getElementsByClassName("gtmnoscript").length > 0 ){
        // no script for this
      }else{
        document.body.insertAdjacentHTML("afterbegin", noScript);
      }
	  }
    return () => {
      $('.pixelScript').remove()
    }
  }, [])

  return (
    <div className='min-h-0 flex-1 overflow-hidden'>
      <Header />
      <main className=" font-segeo ">
        <div className="overflow-x-hidden">
        {isLoadingProfile ?  
                  <Loader /> : 
          <div className=" hidden  md:grid md:grid-cols-9 ">
            <OtpSection />
            <Bannersection />
          </div>
          }
          {/* mobileview */}

          <div className=" px-[1rem] mt-[2rem]  md:hidden ">
            <MobileviewOptSection />
            <Bannersection />

          </div>

        </div>
      </main>
      <div className='md:fixed md:right-0 md:bottom-0 lg:relative '>
      <Footer />
      </div>
      <MobileFooter/>

    </div>
  )
}

export default ProfileRegisterationOtp
